import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/request';

const SELECTOR_WRAPPER = '.p-school-portal-landing__voucher';

const CLICK_EVENT = 'click';
const IS_LOCAL = false;

class ViewVoucher {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	init() {
        const vouchersBtns = this._wrapper.querySelectorAll('.p-school-portal-landing__voucher-card-btn', this._wrapper);
        this.errorContainer = SelectorEngine.findOne('.p-school-portal-landing__voucher-error', this._wrapper);
        this.errorBtn = SelectorEngine.findOne('.p-school-portal-landing__voucher-error-close', this._wrapper);
		this.blockId = this._wrapper.getAttribute('data-blockId');
        vouchersBtns.forEach(button => {
            button.addEventListener(CLICK_EVENT, (e) => {
                const voucherId = button.getAttribute('data-voucherId');
                this.redeemVoucher(voucherId, this.blockId);
            });
        })

        this.errorBtn.addEventListener(CLICK_EVENT, (e) => {
            this.errorContainer.classList.add('u-hidden');
        });
	}

    async redeemVoucher(voucherId, blockId) {
		const payload =  {
			voucherId : voucherId,
			blockId : blockId
		}
		try {
			const url = `/api/schoolvoucher/viewvoucher`;
			const responseData = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
			 }
			});
			const { success, returnUrl } = responseData;

			if (success && returnUrl) {
				window.location = returnUrl;
			}else {
				this.errorContainer.classList.remove('u-hidden');
				scrollToNode(this.errorContainer);
			}
		} catch (error) {
			if (error.hasError) {
				this.errorContainer.classList.remove('u-hidden');
			}
		}
	}
}

const globalViewVoucher = new ViewVoucher();
export default globalViewVoucher;
